var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "#E22613"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2907 20.6778L20.5707 12.3078L17.8557 20.6778H9.05566L16.1707 25.8478L13.4557 34.2178L20.5707 29.0428L27.6907 34.2178L24.9707 25.8478L32.0907 20.6778H23.2907Z",
    fill: "#FEE400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6252 31.1078L49.6952 31.2128L48.6902 28.4578L47.8802 31.2778L44.9502 31.3828L47.3852 33.0228L46.5802 35.8428L48.8902 34.0328L51.3202 35.6728L50.3152 32.9178L52.6252 31.1078Z",
    fill: "#FEE400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7259 21.4578L48.1409 24.3578L49.5109 21.7678L52.4009 22.2678L50.3609 20.1628L51.7309 17.5728L49.0959 18.8628L47.0559 16.7578L47.4709 19.6628L44.8359 20.9528L47.7259 21.4578Z",
    fill: "#FEE400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1559 13.7278L41.6659 16.2428L41.9209 13.3178L44.7809 12.6628L42.0809 11.5128L42.3409 8.59277L40.4109 10.8028L37.7159 9.65777L39.2209 12.1728L37.2959 14.3828L40.1559 13.7278Z",
    fill: "#FEE400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1857 36.7928L40.3507 39.0828L37.6057 38.0478L39.2207 40.4978L37.3857 42.7878L40.2157 42.0128L41.8257 44.4628L41.9607 41.5328L44.7907 40.7528L42.0457 39.7228L42.1857 36.7928Z",
    fill: "#FEE400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/China.b4694876139a6402983f5d6e6d7cdeb3.svg";
export { ForwardRef as ReactComponent };